// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgExplore: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M0 3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1z" />
        <path d="M11 3a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v6.755A7.966 7.966 0 0 0 15 8c-1.457 0-2.823.39-4 1.07z" />
        <path d="M0 14a1 1 0 0 1 1-1h6.581A7.978 7.978 0 0 0 7 16c0 2.011.742 3.849 1.967 5.254A1 1 0 0 1 8 22H1a1 1 0 0 1-1-1z" />
        <path
          fillRule="evenodd"
          d="M20.588 18.19a6 6 0 1 0-1.033 1.715l2.89 1.927a1 1 0 1 0 1.11-1.664zM15 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgExplore);
export default Memo;
